import { memo } from 'react';

import './styles.scss';

const AutomationTemplateImage = memo(({ firstIcon, secondIcon }) => {
    return (
        <div className="fm-automations-settings__template__image">
            <div className="fm-automations-settings__template__image__icon">{firstIcon}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width={34} height={32} fill="none">
                <path
                    fill="#B3D9C8"
                    d="M28.998 13.163a.75.75 0 0 1 1.054.12l1.786 2.25a.75.75 0 0 1 0 .932l-1.786 2.249a.75.75 0 1 1-1.174-.933l1.016-1.28h-.313a.5.5 0 0 1 0-1h.317l-1.02-1.284a.75.75 0 0 1 .12-1.054ZM3.978 14c.921 0 1.694.638 1.914 1.5h.384a.5.5 0 0 1 0 1h-.385A1.98 1.98 0 0 1 3.978 18 1.99 1.99 0 0 1 2 16c0-1.104.885-2 1.978-2Zm5.406 1.5a.5.5 0 0 1 0 1H7.83a.5.5 0 0 1 0-1h1.554Zm3.107 0a.5.5 0 0 1 0 1h-1.553a.5.5 0 0 1 0-1h1.553Zm3.108 0a.5.5 0 0 1 0 1h-1.554a.5.5 0 0 1 0-1h1.554Zm6.215 0a.5.5 0 0 1 0 1H20.26a.5.5 0 0 1 0-1h1.553Zm3.106 0a.5.5 0 0 1 0 1h-1.554a.5.5 0 0 1 0-1h1.554Zm3.107 0a.5.5 0 1 1 0 1h-1.553a.5.5 0 0 1 0-1h1.553Zm-9.32 0a.501.501 0 0 1 0 1h-1.555a.5.5 0 0 1 0-1h1.554Z"
                />
                <circle cx={4} cy={16} r={1} fill="#B3D9C8" />
                <path
                    fill="#007E45"
                    d="m14.75 23 .688-4.9H12L18.188 9h1.375l-.688 5.6H23L16.125 23H14.75Z"
                />
            </svg>
            <div className="fm-automations-settings__template__image__icon">{secondIcon}</div>
        </div>
    );
});

export default AutomationTemplateImage;
